var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "subheader" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "main-container" } }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { attrs: { id: "container" } }, [
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      background: "white"
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: {
                          width: "100%",
                          height: "60px",
                          "margin-top": "5px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Nombre(*)")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nombre,
                                  expression: "nombre"
                                }
                              ],
                              class: [_vm.errorNombre ? "inpt-error" : "inpt"],
                              attrs: { type: "text" },
                              domProps: { value: _vm.nombre },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.nombre = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Contacto")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contacto,
                                  expression: "contacto"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "text" },
                              domProps: { value: _vm.contacto },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.contacto = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Teléfono")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.telefono,
                                  expression: "telefono"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "tel" },
                              domProps: { value: _vm.telefono },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.telefono = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Correo electrónico")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                }
                              ],
                              class: [_vm.errorEmail ? "inpt-error" : "inpt"],
                              attrs: { type: "email" },
                              domProps: { value: _vm.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: { width: "100%", height: "60px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Inicio horario de atención")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hIniAte,
                                  expression: "hIniAte"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "time" },
                              domProps: { value: _vm.hIniAte },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.hIniAte = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Fin horario de atención")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hFinAte,
                                  expression: "hFinAte"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "time" },
                              domProps: { value: _vm.hFinAte },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.hFinAte = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Inicio horario de recepción")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hIniRecep,
                                  expression: "hIniRecep"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "time" },
                              domProps: { value: _vm.hIniRecep },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.hIniRecep = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Fin horario de recepción")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hFinRecep,
                                  expression: "hFinRecep"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "time" },
                              domProps: { value: _vm.hFinRecep },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.hFinRecep = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: { width: "100%", height: "60px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Ciudad")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ciudad,
                                  expression: "ciudad"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "text" },
                              domProps: { value: _vm.ciudad },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.ciudad = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "50%",
                              height: "100%",
                              "padding-left": "10px"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Dirección")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              ref: "autocompletePc",
                              staticClass: "inpt",
                              staticStyle: { width: "365px" },
                              attrs: { type: "text" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "5px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Observaciones")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.observaciones,
                                  expression: "observaciones"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "text" },
                              domProps: { value: _vm.observaciones },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.observaciones = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: {
                          width: "100%",
                          height: "60px",
                          background: "white",
                          "margin-top": "5px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v(_vm._s(_vm.idFiscalProp))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.idFiscal,
                                  expression: "idFiscal"
                                }
                              ],
                              class: [
                                _vm.errorIdFiscal ? "inpt-error" : "inpt"
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.idFiscal },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.idFiscal = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Razon social")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.razonSocial,
                                  expression: "razonSocial"
                                }
                              ],
                              staticClass: "inpt",
                              attrs: { type: "text" },
                              domProps: { value: _vm.razonSocial },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.razonSocial = $event.target.value
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "fv lt",
                          staticStyle: {
                            width: "50%",
                            height: "100%",
                            "padding-left": "10px"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh lt",
                        staticStyle: {
                          width: "100%",
                          height: "60px",
                          "margin-top": "5px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Agrupación(*)")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.agrupacion,
                                    expression: "agrupacion"
                                  }
                                ],
                                class: [
                                  _vm.errorAgrupacion ? "wc-error" : "wc"
                                ],
                                staticStyle: { width: "180px" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.agrupacion = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.agrupaciones, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option } },
                                  [_vm._v(_vm._s(option.Nombre))]
                                )
                              })
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Tipo cliente(*)")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tipoCliente,
                                    expression: "tipoCliente"
                                  }
                                ],
                                class: [
                                  _vm.errorTipoCliente ? "wc-error" : "wc"
                                ],
                                staticStyle: { width: "180px" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.tipoCliente = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.tipoClientes, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option } },
                                  [_vm._v(_vm._s(option.Nombre))]
                                )
                              })
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Lista de precio(*)")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.listaPrecio,
                                    expression: "listaPrecio"
                                  }
                                ],
                                class: [
                                  _vm.errorListaPrecio ? "wc-error" : "wc"
                                ],
                                staticStyle: { width: "180px" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.listaPrecio = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.listaPrecios, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option } },
                                  [_vm._v(_vm._s(option.Nombre))]
                                )
                              })
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fv lt",
                            staticStyle: {
                              width: "25%",
                              height: "100%",
                              "padding-left": "10px",
                              background: "white"
                            }
                          },
                          [
                            _c("div", { staticClass: "labels-forms" }, [
                              _vm._v("Depósito(*)")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.deposito,
                                    expression: "deposito"
                                  }
                                ],
                                class: [_vm.errorDeposito ? "wc-error" : "wc"],
                                staticStyle: { width: "180px" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.deposito = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.depositos, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option } },
                                  [_vm._v(_vm._s(option.Nombre))]
                                )
                              })
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh rc",
                  staticStyle: { "text-align": "center", "margin-top": "30px" }
                },
                [
                  _c(
                    "button",
                    { attrs: { id: "btnok" }, on: { click: _vm.saveCliente } },
                    [_vm._v("GUARDAR")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { attrs: { id: "btncancel" }, on: { click: _vm.exit } },
                    [_vm._v("CANCELAR")]
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
            _c(
              "div",
              {
                staticClass: "fh cc",
                staticStyle: {
                  width: "100vw",
                  height: "4vh",
                  background: "#44C7F4",
                  color: "white",
                  font: "size 12px"
                }
              },
              [_vm._v("Nuevo Clientes")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: { height: "60vh", overflow: "auto" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "labels-forms",
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-top": "10px",
                      "padding-bottom": "5px",
                      "font-size": "15px",
                      "font-weight": "500"
                    }
                  },
                  [_vm._v("Informacióm Básica")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Nombre(*)")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nombre,
                          expression: "nombre"
                        }
                      ],
                      class: [_vm.errorNombre ? "inpt-cel-error" : "inpt-cel"],
                      attrs: { type: "text" },
                      domProps: { value: _vm.nombre },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.nombre = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Contacto")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contacto,
                          expression: "contacto"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "text" },
                      domProps: { value: _vm.contacto },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.contacto = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Teléfono")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.telefono,
                          expression: "telefono"
                        }
                      ],
                      class: [_vm.errorEmail ? "inpt-cel-error" : "inpt-cel"],
                      attrs: { type: "text" },
                      domProps: { value: _vm.telefono },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.telefono = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Correo electrónico")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "text" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Inicio horario de atención")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hIniAte,
                          expression: "hIniAte"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "time" },
                      domProps: { value: _vm.hIniAte },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.hIniAte = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Fin horario de atención")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hIniAte,
                          expression: "hIniAte"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "time" },
                      domProps: { value: _vm.hIniAte },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.hIniAte = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Inicio horario de recepción")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hIniAte,
                          expression: "hIniAte"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "time" },
                      domProps: { value: _vm.hIniAte },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.hIniAte = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Fin horario de recepción")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hIniAte,
                          expression: "hIniAte"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "time" },
                      domProps: { value: _vm.hIniAte },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.hIniAte = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Ciudad")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ciudad,
                          expression: "ciudad"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "text" },
                      domProps: { value: _vm.ciudad },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.ciudad = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Dirección")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "autocompleteMobile",
                      staticClass: "inpt-cel",
                      attrs: { type: "text" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Observaciones")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.observaciones,
                          expression: "observaciones"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "text" },
                      domProps: { value: _vm.observaciones },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.observaciones = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "labels-forms",
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-top": "30px",
                      "font-size": "15px",
                      "font-weight": "500"
                    }
                  },
                  [_vm._v("Datos Fiscales")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v(_vm._s(_vm.idFiscalProp))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.idFiscal,
                          expression: "idFiscal"
                        }
                      ],
                      class: [
                        _vm.errorIdFiscal ? "inpt-cel-error" : "inpt-cel"
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.idFiscal },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.idFiscal = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Razon social")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.razonSocial,
                          expression: "razonSocial"
                        }
                      ],
                      staticClass: "inpt-cel",
                      attrs: { type: "text" },
                      domProps: { value: _vm.razonSocial },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.razonSocial = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "labels-forms",
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-top": "30px",
                      "font-size": "15px",
                      "font-weight": "500"
                    }
                  },
                  [_vm._v("Datos Financieros")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Agrupación(*)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agrupacion,
                            expression: "agrupacion"
                          }
                        ],
                        class: [_vm.errorAgrupacion ? "wc-error" : "wc"],
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-right": "10px",
                          width: "90%"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.agrupacion = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.agrupaciones, function(option) {
                        return _c("option", { domProps: { value: option } }, [
                          _vm._v(_vm._s(option.Nombre))
                        ])
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Tipo cliente(*)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tipoCliente,
                            expression: "tipoCliente"
                          }
                        ],
                        class: [_vm.errorTipoCliente ? "wc-error" : "wc"],
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-right": "10px",
                          width: "90%"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.tipoCliente = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.tipoClientes, function(option) {
                        return _c("option", { domProps: { value: option } }, [
                          _vm._v(_vm._s(option.Nombre))
                        ])
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Lista de precio(*)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.listaPrecio,
                            expression: "listaPrecio"
                          }
                        ],
                        class: [_vm.errorListaPrecio ? "wc-error" : "wc"],
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-right": "10px",
                          width: "90%"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.listaPrecio = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.listaPrecios, function(option) {
                        return _c("option", { domProps: { value: option } }, [
                          _vm._v(_vm._s(option.Nombre))
                        ])
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fv lt",
                    staticStyle: {
                      width: "90%",
                      "padding-left": "10px",
                      "margin-top": "20px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fc lt",
                        staticStyle: {
                          width: "95%",
                          "font-size": "12px",
                          color: "#5C666F",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("Depósito(*)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.deposito,
                            expression: "deposito"
                          }
                        ],
                        class: [_vm.errorDeposito ? "wc-error" : "wc"],
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-right": "10px",
                          width: "90%"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.deposito = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.depositos, function(option) {
                        return _c("option", { domProps: { value: option } }, [
                          _vm._v(_vm._s(option.Nombre))
                        ])
                      })
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh cc",
                staticStyle: { width: "100vw", height: "19vh" }
              },
              [
                _c(
                  "button",
                  { attrs: { id: "btnok" }, on: { click: _vm.saveCliente } },
                  [_vm._v("GUARDAR")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { attrs: { id: "btncancel" }, on: { click: _vm.exit } },
                  [_vm._v("CANCELAR")]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Nuevo Cliente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fh lt",
        staticStyle: { width: "100%", background: "#f0f0f0" }
      },
      [
        _c(
          "div",
          {
            staticClass: "labels-forms",
            staticStyle: {
              "padding-left": "10px",
              "padding-top": "10px",
              "padding-bottom": "5px",
              "font-size": "15px",
              "font-weight": "500"
            }
          },
          [_vm._v("Informacióm Básica")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fh lt",
        staticStyle: { width: "100%", background: "#f0f0f0" }
      },
      [
        _c(
          "div",
          {
            staticClass: "labels-forms",
            staticStyle: {
              "padding-left": "10px",
              "padding-top": "10px",
              "padding-bottom": "5px",
              "font-size": "15px",
              "font-weight": "500"
            }
          },
          [_vm._v("Datos Fiscales")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fh lt",
        staticStyle: { width: "100%", background: "#f0f0f0" }
      },
      [
        _c(
          "div",
          {
            staticClass: "labels-forms",
            staticStyle: {
              "padding-left": "10px",
              "padding-top": "10px",
              "padding-bottom": "5px",
              "font-size": "15px",
              "font-weight": "500"
            }
          },
          [_vm._v("Datos Financieros")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c538ba8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c538ba8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/altaClientes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c538ba8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/altaClientes.vue
// module chunks = 0